import { MenuOutlined } from '@ant-design/icons'
import appStore from '@stores/appStore'
import dashboardStore from '@stores/dashboard'
import { observer } from 'mobx-react'

import Tooltip from '../../../components/shared/Tooltip'

const ToggleAutoHideIcon = () => {
  const {
    sidebar: { collapsed, visible },
    toggleSidebar,
  } = dashboardStore

  const renderTenantLabel = () => {
    let edition = ''
    if (appStore.edition.FUNDING_PROVIDER) {
      edition = 'FP'
    } else if (appStore.edition.LAW_CONNECT) {
      edition = 'LC'
    } else if (appStore.edition.MLP) {
      edition = 'MLP'
    } else if (appStore.edition.LMQ_PROVIDER) {
      edition = 'LMQ'
    } else {
      edition = 'MASTER'
    }

    return `${edition}${
      appStore.currentTenant.name ? '-' + appStore.currentTenant.name : ''
    }`
  }

  return (
    <div>
      <span
        className="DashboardHeaderIcon flex items-center"
        style={{ left: 16, width: 250, fontSize: '16px', textAlign: 'left' }}
      >
        {renderTenantLabel()}
      </span>
      <Tooltip>
        <div
          onClick={toggleSidebar}
          className="DashboardHeaderIcon r-0 flex items-center justify-center cursor-pointer"
        >
          <MenuOutlined />
        </div>
      </Tooltip>
    </div>
  )
}

export default observer(ToggleAutoHideIcon)
